import { FC } from 'react';
import classNames from 'classnames';

type Props = {
  className?: string;
};

const User: FC<Props> = ({ className }) => (
  <svg
    className={classNames('stroke-[2px]', className)}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M20.5902 22.0002C20.5902 18.1302 16.7402 15.0002 12.0002 15.0002C7.26016 15.0002 3.41016 18.1302 3.41016 22.0002M12.0002 12.0002C13.3262 12.0002 14.598 11.4735 15.5357 10.5358C16.4734 9.5981 17.0002 8.32633 17.0002 7.00024C17.0002 5.67416 16.4734 4.40239 15.5357 3.46471C14.598 2.52703 13.3262 2.00024 12.0002 2.00024C10.6741 2.00024 9.4023 2.52703 8.46462 3.46471C7.52694 4.40239 7.00016 5.67416 7.00016 7.00024C7.00016 8.32633 7.52694 9.5981 8.46462 10.5358C9.4023 11.4735 10.6741 12.0002 12.0002 12.0002Z"
      stroke="currentColor"
      strokeWidth="currentStrokWidth"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default User;
